import React from "react";

function Footer(){
    return(
        <footer style={{ backgroundColor: '#333', color: '#fff', textAlign: 'center', padding: '10px 0' }}>
            &copy; 2026 Sergipanidade. Todos os direitos reservados.
        </footer>
    )
}

export default Footer;